import styled from 'styled-components';

export const ProfilePageContainer = styled.main`
    input[readonly] {
        opacity: 0.5;
        pointer-events: none;
        cursor: not-allowed;
        background: ${props => props.theme.whiteSmoke};
    }

    .form-input-container .item-wrapper-box-input .label {
        margin-bottom: 15px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/ProfilePageStyle.js